//auth
export const API_LOGIN = "/user/login";
export const API_AUTH_TOKEN = "/user/createAuthToken";
export const API_CHECK_AUTH = "/user/checkAuthToken";
export const API_LOGOUT = "/user/logout";
export const API_DOLLAR_RATE = "/user/getDollarRate";
export const API_DOLLAR_RATE_UPDATE = "/user/updateDollarRate";

// live market
export const API_LIVE_MARKET = "/instruments/isBadlalist";

// badla
export const API_GET_BADLA_LIST = "/badlainstruments/getBadlaInstrument";
export const API_GET_SCRIPTS = "/userScript/getUserScript";
export const API_ADD_SCRIPTS = "/userScript/addUserScript";
export const API_DELETE_SCRIPTS = "/userScript/deleteUserScript";
export const API_UPDATE_SCRIPTS = "/userScript/updateUserScript";
export const API_HISTORY_DAYWISE = "/historySummary/getHistoryDayWise";
export const API_HISTORY_MINUTEWISE = "/historySummary/getHistoryMinitely";

// badla order
export const API_BADLA_LAST_PRICE = "/badlaOrder/getBadlaLastPrice";
export const API_BADLA_ORDER_ADD = "/badlaOrder/add";
export const API_BADLA_ORDER_FETCH = "/badlaOrder/get";
export const API_BADLA_ORDER_DELETE = "/badlaOrder/delete";
export const API_BADLA_ORDER_EDIT = "/badlaOrder/update";
export const API_BADLA_ORDER_AVERAGE = "/badlaOrder/averageBadla";

export const API_BADLA_ORDER_OLD = "/instruments/getBadlaOrderOld";
export const API_BADLA_ORDER_PL = "/instruments/getOrderPLOld";
export const API_BADLA_ORDER_GROUP = "/instruments/getBadlaOrderGroup";
